/** @format */

// mixpanel.track бросает, если библиотека не инициализирована (нет VITE_MIXPANEL_PROJECT_TOKEN).
// Аналитика не должна ронять страницу — глотаем ошибку с предупреждением.
// Mixpanel — глобальный тип из src/index.d.ts (минимальный стаб, совместимый с useMixpanelContext).
export const trackOverviewEvent = (
  mixpanel: Mixpanel,
  event: string,
  params?: Record<string, unknown>,
): void => {
  try {
    mixpanel.track(event, params);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`[overview] mixpanel.track('${event}') failed:`, error);
  }
};
